<template>
  <v-card
    v-touch="{
      right: () => this.$emit('update:modelValue', val),
    }"
  >
    <header>
      <div class="header-container">
        <div class="btn__block">
          <button
            class="btn-reset close__card flex"
            @click="this.$emit('update:modelValue', val)"
          >
            <svg
              width="10"
              height="16"
              viewBox="0 0 10 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M10 2.28571L3.75 8L10 13.7143L8.75 16L0 8L8.75 0L10 2.28571Z"
                fill="#fff"
              />
            </svg>
            <span>Назад</span>
          </button>
        </div>

        <div class="logo">
          <svg
            width="92"
            height="61"
            viewBox="0 0 92 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.4519 10.082C19.2157 10.8168 17.8387 11.8015 16.3556 13.0717C15.5604 11.3842 14.8972 9.31956 14.4131 7.13302C17.0286 3.74996 19.3203 2.39136 19.3203 2.39136C19.3501 4.07278 19.6253 7.06889 20.4519 10.082Z"
              fill="#EC4900"
            />
            <path
              d="M20.4519 10.082C19.2157 10.8168 17.8387 11.8015 16.3556 13.0717C15.5604 11.3842 14.8972 9.31956 14.4131 7.13302C17.0286 3.74996 19.3203 2.39136 19.3203 2.39136C19.3501 4.07278 19.6253 7.06889 20.4519 10.082Z"
              fill="url(#paint0_linear_803_4260)"
            />
            <path
              d="M19.195 10.4462C18.5235 8.4486 18.2238 6.44144 18.1397 5.30984C18.1397 5.30984 16.6481 6.31236 15.0156 8.69025L16.0482 12.5076L19.2748 11.2337"
              fill="url(#paint1_linear_803_4260)"
            />
            <path
              d="M29.9999 60.1947C29.679 60.1947 29.3583 60.191 29.0453 60.1833C-0.169037 59.5222 -4.07292 29.9872 6.12764 17.0654C8.80253 13.6794 7.08252 5.83281 15.3387 0C15.1995 1.56938 15.1841 3.22764 15.2847 4.83162C15.4007 6.7797 15.6868 8.65061 16.139 10.216C17.5923 9.32685 18.9182 8.66604 20.0817 8.2059C22.0492 7.41363 23.572 7.17012 24.5423 7.23186C25.7136 7.31303 26.9466 8.42626 28.8869 8.89784C32.9726 8.2059 36.2388 7.02321 40.3591 4.94739C44.2515 15.6001 34.0238 21.6418 25.4467 32.0973C18.1025 41.0652 17.3331 54.331 29.9999 60.1947Z"
              fill="url(#paint2_linear_803_4260)"
            />
            <path
              d="M29.0453 60.1833L26.5243 60.0858C25.6865 60.0145 24.8508 59.9083 24.013 59.821C23.1811 59.6938 22.3545 59.5275 21.5239 59.3822C20.7071 59.1759 19.8867 58.975 19.0752 58.7448C15.851 57.7455 12.7937 56.1671 10.1505 54.0409C8.86189 52.9445 7.61746 51.7748 6.587 50.4237C6.03105 49.7804 5.58342 49.0571 5.09453 48.3638C4.86433 48.008 4.66127 47.6346 4.44357 47.2708L4.12209 46.7215C4.01909 46.5363 3.9318 46.3425 3.83573 46.1536L3.2726 45.0124L2.78877 43.8359C2.70999 43.6389 2.62377 43.4449 2.55138 43.2458L2.34938 42.6428C2.21871 42.2396 2.07128 41.8412 1.95445 41.4337C1.74207 40.613 1.49909 39.7989 1.35645 38.9622L1.2327 38.3384L1.17122 38.0265L1.12837 37.7114L0.957251 36.451C0.610481 33.0796 0.787191 29.6468 1.5768 26.3475C1.97068 24.7005 2.48458 23.0749 3.19968 21.5348C3.90679 19.9958 4.73526 18.498 5.79952 17.1697C6.86138 15.9008 7.24195 14.2319 7.65366 12.6146C8.05232 10.9848 8.45232 9.33588 9.07932 7.76197C9.70313 6.1894 10.5505 4.70306 11.6121 3.3889C12.1457 2.73422 12.7328 2.12584 13.3539 1.55711C13.9772 0.989189 14.6524 0.484604 15.339 0.000244141C13.9868 0.998504 12.7509 2.15405 11.7228 3.47645C10.7019 4.80392 9.90167 6.28973 9.32283 7.85592C8.73042 9.41971 8.35544 11.054 7.98073 12.6929C7.79098 13.5123 7.59431 14.3354 7.32205 15.1445C7.18101 15.5471 7.02904 15.9495 6.82545 16.3327C6.73257 16.5278 6.61281 16.7117 6.49705 16.8959L6.1242 17.4188L5.39819 18.4333L4.75096 19.5002L4.58888 19.7666L4.44437 20.0431L4.15775 20.5975L3.87086 21.1519C3.78144 21.3397 3.70373 21.533 3.61936 21.7232C2.92476 23.2373 2.42763 24.8372 2.04839 26.458C1.28699 29.7045 1.13157 33.0825 1.48552 36.3929L1.64786 37.6318L1.68831 37.9416L1.7474 38.2481L1.86609 38.8616C2.00182 39.6847 2.23708 40.4847 2.44147 41.2922C2.55404 41.693 2.69749 42.0844 2.82363 42.4812L3.01897 43.0745C3.08897 43.2703 3.17306 43.4611 3.24944 43.6546L3.7189 44.8123L4.26633 45.9348C4.35948 46.1209 4.44411 46.3117 4.54444 46.494L4.85741 47.0342C5.06952 47.3922 5.26672 47.7597 5.49107 48.1102C5.96798 48.792 6.40337 49.505 6.94628 50.1381C7.95545 51.4653 9.15996 52.6278 10.4097 53.7272C12.9779 55.8554 15.9729 57.4559 19.1529 58.4976C22.334 59.5581 25.6899 60.0345 29.0453 60.1833Z"
              fill="url(#paint3_linear_803_4260)"
            />
            <path
              d="M30.0004 60.1948C0.535089 56.9829 3.29886 24.8464 15.7645 18.9247C14.0878 18.6299 10.9954 18.6626 10.9954 18.6626C15.2061 13.794 35.0755 13.7283 40.3593 4.94751C44.2517 15.6002 34.024 21.6419 25.4469 32.0975C18.103 41.0653 17.3336 54.3312 30.0004 60.1948Z"
              fill="url(#paint4_linear_803_4260)"
            />
            <path
              d="M30.2551 23.7988C28.1638 25.9866 26.0071 28.2477 23.8927 30.826C19.1654 36.593 17.1824 43.6897 18.5818 49.8046C19.204 52.5064 20.4372 54.9183 22.2384 56.9824C16.0152 54.8875 11.1876 44.5671 12.7298 35.932C11.6783 37.5554 10.8049 39.322 10.2058 41.1617C7.96764 18.7274 34.967 17.4441 39.0566 7.80399C39.9843 13.2621 36.3354 17.4326 30.2551 23.7988Z"
              fill="url(#paint5_linear_803_4260)"
            />
            <path
              d="M30.255 23.7988C28.1637 25.9866 26.007 28.2477 23.8926 30.826C19.1653 36.593 17.1823 43.6897 18.5816 49.8046C19.2039 52.5064 20.4371 54.9183 22.2383 56.9824C12.7914 49.6769 15.0157 35.1107 20.4515 28.2024C18.8744 28.5966 16.2652 30.385 16.2652 30.385C20.4515 21.2285 39.1996 17.0654 39.0565 7.80399C39.9842 13.2621 36.3353 17.4326 30.255 23.7988Z"
              fill="url(#paint6_linear_803_4260)"
            />
            <path
              d="M12.73 35.9324C11.7203 37.5893 10.8791 39.3501 10.3157 41.1978L10.1531 41.7311L10.0911 41.1736C9.98194 40.1942 9.921 39.2085 9.92393 38.2206C9.93351 37.233 9.99924 36.2446 10.1355 35.2636C10.4123 33.3028 10.9956 31.376 11.8962 29.6027C12.788 27.825 13.9771 26.2053 15.3453 24.7711C16.0287 24.0525 16.7558 23.3771 17.5127 22.7397C18.2733 22.1063 19.0653 21.5131 19.8751 20.9489C23.1241 18.6964 26.6405 16.9085 30.1028 15.0783C31.8298 14.154 33.5394 13.1949 35.1372 12.0713C35.9306 11.5042 36.6976 10.8937 37.3754 10.1911C37.7179 9.84298 38.0256 9.46321 38.3167 9.07093C38.5993 8.67227 38.8474 8.24912 39.056 7.80441C38.8695 8.25843 38.6411 8.69569 38.3758 9.11112C38.1017 9.52016 37.8009 9.91298 37.4688 10.2781C36.8093 11.0132 36.0567 11.6585 35.2759 12.2603C33.7012 13.4512 31.9918 14.4396 30.2841 15.4089L25.1387 18.2642C23.4357 19.2294 21.7609 20.2418 20.1684 21.3675C19.3721 21.9301 18.598 22.522 17.8531 23.1472C17.1047 23.7681 16.3872 24.4251 15.7131 25.1235C14.3638 26.5177 13.1936 28.0884 12.3119 29.8143C11.4326 31.5396 10.8227 33.402 10.5046 35.32C10.3497 36.2797 10.2638 37.2511 10.2326 38.2251C10.2068 39.2 10.2531 40.1753 10.3202 41.1504L10.0956 41.1262C10.7372 39.2817 11.6317 37.5332 12.73 35.9324Z"
              fill="url(#paint7_linear_803_4260)"
            />
            <path
              d="M30 60.1948C27.6205 59.9763 25.2498 59.5518 22.9581 58.8343C20.6646 58.1275 18.4637 57.1002 16.4491 55.777C15.4415 55.1154 14.4906 54.3654 13.6063 53.5436C12.7262 52.717 11.9142 51.8167 11.1842 50.8538C9.72206 48.9289 8.59473 46.7538 7.83147 44.4613C7.05995 42.1694 6.67379 39.7566 6.61578 37.3452C6.55856 34.9325 6.834 32.5125 7.44824 30.1791C8.06087 27.8478 9.02666 25.5979 10.3845 23.6011C11.7271 21.607 13.528 19.8607 15.7273 18.8483L15.7489 19.0074C14.9718 18.8661 14.176 18.8028 13.3824 18.7535C12.5878 18.7064 11.7915 18.6737 10.9947 18.6623C11.7915 18.6426 12.5891 18.6364 13.3867 18.6588C14.1843 18.6838 14.9822 18.7219 15.7784 18.8414L16.0379 18.8802L15.8 19.0005C14.7418 19.536 13.7705 20.2335 12.9212 21.0574C12.0624 21.8715 11.3133 22.7979 10.669 23.7906C9.36598 25.772 8.48535 28.0051 7.89188 30.2935C6.71557 34.8827 6.86274 39.8035 8.32221 44.2987C9.0546 46.5451 10.1434 48.6774 11.5616 50.5688C12.2697 51.5149 13.0586 52.4006 13.9155 53.2155C14.7693 54.0333 15.6861 54.7891 16.6652 55.4574C18.6199 56.7995 20.7788 57.8432 23.0332 58.6049C25.2828 59.3926 27.6335 59.8669 30 60.1948Z"
              fill="url(#paint8_linear_803_4260)"
            />
            <path
              d="M46.9967 49.2377H45.6252C45.0633 49.2377 44.6062 49.0663 44.2538 48.7234C43.9014 48.371 43.7252 47.871 43.7252 47.2234V29.7234L43.9109 29.5377H45.1395C45.8062 29.5377 46.2824 29.7091 46.5681 30.052C46.8538 30.3853 46.9967 30.9139 46.9967 31.6377V49.2377ZM55.1252 46.3948C55.1252 47.4805 54.9538 48.2282 54.6109 48.6377C54.2776 49.0377 53.7157 49.2377 52.9252 49.2377H45.6252L43.9252 46.8377C44.8586 46.6853 45.8252 46.5758 46.8252 46.5091C47.8252 46.4329 48.7347 46.3948 49.5538 46.3948H55.1252ZM61.3654 49.1948C60.9083 49.2805 60.3797 49.3234 59.7797 49.3234C59.1797 49.3234 58.6511 49.2805 58.194 49.1948V38.8663C58.194 38.371 58.1035 37.9996 57.9225 37.752C57.7416 37.4948 57.413 37.3663 56.9368 37.3663H56.594C56.5083 37.0043 56.4654 36.6329 56.4654 36.252C56.4654 36.071 56.4749 35.8853 56.494 35.6948C56.513 35.4948 56.5464 35.2948 56.594 35.0948C56.9654 35.0472 57.3225 35.0139 57.6654 34.9948C58.0083 34.9758 58.2892 34.9663 58.5083 34.9663H58.9368C59.6892 34.9663 60.2797 35.2043 60.7083 35.6805C61.1464 36.1567 61.3654 36.8091 61.3654 37.6377V49.1948ZM57.3083 31.2234C57.3083 30.7282 57.3987 30.2853 57.5797 29.8948C57.7702 29.7901 58.0178 29.7043 58.3225 29.6377C58.6368 29.5615 58.9416 29.5234 59.2368 29.5234C59.513 29.5234 59.8178 29.5615 60.1511 29.6377C60.4844 29.7043 60.7321 29.7901 60.894 29.8948C60.9702 30.0758 61.0321 30.2901 61.0797 30.5377C61.1368 30.7853 61.1654 31.0139 61.1654 31.2234C61.1654 31.7186 61.0749 32.1663 60.894 32.5663C60.7416 32.671 60.494 32.7567 60.1511 32.8234C59.8178 32.8901 59.513 32.9234 59.2368 32.9234C58.9416 32.9234 58.6321 32.8901 58.3083 32.8234C57.994 32.7567 57.7511 32.671 57.5797 32.5663C57.3987 32.1663 57.3083 31.7186 57.3083 31.2234ZM64.3051 48.1663C64.3242 47.8043 64.4337 47.4091 64.6337 46.9805C64.8337 46.5424 65.0623 46.1996 65.3194 45.952C65.9289 46.2758 66.5766 46.5663 67.2623 46.8234C67.948 47.0805 68.6385 47.2091 69.3337 47.2091C70.0766 47.2091 70.6623 47.052 71.0908 46.7377C71.5289 46.4234 71.748 46.0234 71.748 45.5377C71.748 45.1567 71.6051 44.8091 71.3194 44.4948C71.0337 44.171 70.6051 43.9043 70.0337 43.6948L68.3766 43.0805C67.7194 42.8424 67.1147 42.5424 66.5623 42.1805C66.0194 41.8186 65.5813 41.3758 65.248 40.852C64.9242 40.3282 64.7623 39.7043 64.7623 38.9805C64.7623 38.0948 64.9813 37.3329 65.4194 36.6948C65.867 36.0472 66.4766 35.552 67.248 35.2091C68.0289 34.8567 68.9099 34.6805 69.8908 34.6805C70.6813 34.6805 71.5194 34.7901 72.4051 35.0091C73.3004 35.2186 74.0432 35.4615 74.6337 35.7377C74.6528 36.1282 74.5718 36.552 74.3908 37.0091C74.2194 37.4663 73.9956 37.8091 73.7194 38.0377C73.2051 37.8091 72.6099 37.5948 71.9337 37.3948C71.267 37.1853 70.5813 37.0805 69.8766 37.0805C69.2956 37.0805 68.8289 37.2234 68.4766 37.5091C68.1242 37.7948 67.948 38.171 67.948 38.6377C67.948 39.0091 68.0861 39.3234 68.3623 39.5805C68.6385 39.8282 69.0575 40.0567 69.6194 40.2663L71.3766 40.9234C72.4528 41.3043 73.3289 41.8424 74.0051 42.5377C74.6908 43.2329 75.0337 44.1424 75.0337 45.2663C75.0337 46.5996 74.5147 47.652 73.4766 48.4234C72.4385 49.1948 71.0623 49.5805 69.348 49.5805C68.3385 49.5805 67.4004 49.4377 66.5337 49.152C65.6766 48.8663 64.9337 48.5377 64.3051 48.1663ZM76.833 48.1663C76.8521 47.8043 76.9616 47.4091 77.1616 46.9805C77.3616 46.5424 77.5902 46.1996 77.8473 45.952C78.4568 46.2758 79.1045 46.5663 79.7902 46.8234C80.4759 47.0805 81.1664 47.2091 81.8616 47.2091C82.6045 47.2091 83.1902 47.052 83.6187 46.7377C84.0568 46.4234 84.2759 46.0234 84.2759 45.5377C84.2759 45.1567 84.133 44.8091 83.8473 44.4948C83.5616 44.171 83.133 43.9043 82.5616 43.6948L80.9045 43.0805C80.2473 42.8424 79.6426 42.5424 79.0902 42.1805C78.5473 41.8186 78.1092 41.3758 77.7759 40.852C77.4521 40.3282 77.2902 39.7043 77.2902 38.9805C77.2902 38.0948 77.5092 37.3329 77.9473 36.6948C78.3949 36.0472 79.0045 35.552 79.7759 35.2091C80.5568 34.8567 81.4378 34.6805 82.4187 34.6805C83.2092 34.6805 84.0473 34.7901 84.933 35.0091C85.8283 35.2186 86.5711 35.4615 87.1616 35.7377C87.1807 36.1282 87.0997 36.552 86.9187 37.0091C86.7473 37.4663 86.5235 37.8091 86.2473 38.0377C85.733 37.8091 85.1378 37.5948 84.4616 37.3948C83.7949 37.1853 83.1092 37.0805 82.4045 37.0805C81.8235 37.0805 81.3568 37.2234 81.0045 37.5091C80.6521 37.7948 80.4759 38.171 80.4759 38.6377C80.4759 39.0091 80.614 39.3234 80.8902 39.5805C81.1664 39.8282 81.5854 40.0567 82.1473 40.2663L83.9045 40.9234C84.9807 41.3043 85.8568 41.8424 86.533 42.5377C87.2187 43.2329 87.5616 44.1424 87.5616 45.2663C87.5616 46.5996 87.0426 47.652 86.0045 48.4234C84.9664 49.1948 83.5902 49.5805 81.8759 49.5805C80.8664 49.5805 79.9283 49.4377 79.0616 49.152C78.2045 48.8663 77.4616 48.5377 76.833 48.1663Z"
              fill="white"
            />
            <defs>
              <linearGradient
                id="paint0_linear_803_4260"
                x1="17.2779"
                y1="-1.58997"
                x2="17.472"
                y2="11.2207"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.1843" stop-color="#EE5E1F" />
                <stop offset="0.5478" stop-color="#C34712" />
                <stop offset="1" stop-color="#852800" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_803_4260"
                x1="17.3547"
                y1="4.8299"
                x2="17.1573"
                y2="9.66567"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.495" stop-color="#EEEEEE" />
                <stop offset="1" stop-color="#C3C3C3" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_803_4260"
                x1="19.069"
                y1="-0.346876"
                x2="24.7462"
                y2="60.6834"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF8351" />
                <stop offset="0.595" stop-color="#EE5C1D" />
                <stop offset="1" stop-color="#C3440B" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_803_4260"
                x1="10.5261"
                y1="0.216183"
                x2="16.2399"
                y2="61.6399"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#A83400" />
                <stop offset="0.2731" stop-color="#C3440B" />
                <stop offset="0.7546" stop-color="#EE5C1D" />
                <stop offset="1" stop-color="#FF6624" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_803_4260"
                x1="23.4473"
                y1="-15.5777"
                x2="24.4528"
                y2="50.779"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.385" stop-color="#EE5E1F" />
                <stop offset="1" stop-color="#C34712" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_803_4260"
                x1="28.6617"
                y1="3.67056"
                x2="16.8192"
                y2="61.6992"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.2101" stop-color="#EEEEEE" />
                <stop offset="0.6219" stop-color="#C3C3C3" />
                <stop offset="1" stop-color="#969696" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_803_4260"
                x1="33.069"
                y1="-0.758187"
                x2="20.1407"
                y2="50.7576"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.625" stop-color="#EEEEEE" />
                <stop offset="1" stop-color="#C3C3C3" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_803_4260"
                x1="23.1454"
                y1="9.15772"
                x2="26.1034"
                y2="40.9569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.2454" stop-color="#EE5C1D" />
                <stop offset="0.7269" stop-color="#C3440B" />
                <stop offset="1" stop-color="#A83400" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_803_4260"
                x1="15.4132"
                y1="17.9854"
                x2="19.4552"
                y2="61.4376"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.2454" stop-color="#EE5C1D" />
                <stop offset="0.7269" stop-color="#C3440B" />
                <stop offset="1" stop-color="#A83400" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <nav class="menu">
          <a class="menu-triger" href="#"></a>
          <div class="menu-popup">
            <a class="menu-close" href="#"></a>
            <ul class="nav__list">
              <li class="nav__item">
                <a class="navbar__link list-reset" href="#description"
                  >Описание</a
                >
              </li>
              <li class="nav__item">
                <a class="navbar__link list-reset" href="#characteristics"
                  >Дополнительно</a
                >
              </li>
              <!-- <li class="nav__item">
                <a class="navbar__link list-reset" href="#contacts">Контакты</a>
              </li>-->
            </ul>
          </div>
        </nav>
      </div>
    </header>
    <main>
      <section
        class="banner"
        :style="`background-image: url('${item.photos[1]}')`"
      >
        <div class="banner__details">
          <div class="banner__text">
            <div class="banner__title">
              <h1>{{ item.title }}</h1>
            </div>
            <div class="banner__description">
              <p>{{ item.address }}</p>
            </div>
          </div>
        </div>
      </section>
      <section id="description" class="description">
        <div class="description__info">
          <div class="title__block">
            <h2 class="title">Описание</h2>
            <!-- <div class="saled">
              <p>Объявление снято с публикации</p>
            </div> -->
            <p class="price">
              <b>{{ item.currency }} {{ item.fullPrice }} /</b>
              {{ item.squarePrice }} {{ item.currency }} за м²
            </p>
            <span class="description__address">{{ item.address }}</span>
          </div>
          <div class="description__text">
            <p>{{ item.discriptions }}</p>
          </div>
        </div>
        <div class="description__photo">
          <img :src="item.photos[2]" />
        </div>
      </section>
      <section id="characteristics" class="characteristics">
        <div class="characteristics-container">
          <div>
            <h2 class="title">Характеристики</h2>
          </div>
          <div class="characteristics-items">
            <div v-if="item.floor" class="characteristics-item">
              <svg
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.4581 4.69849H27.5163C26.4497 4.69849 25.5854 5.5622 25.5854 6.6291V11.6408H20.5738C19.5069 11.6408 18.6425 12.5042 18.6425 13.5712V18.5832H13.6308C12.5639 18.5832 11.6999 19.4479 11.6999 20.5137V25.7671H6.44761C5.93511 25.7671 5.444 25.9703 5.08205 26.3319C4.71978 26.6938 4.5166 27.1871 4.5166 27.6976L4.51723 31.7369C4.51723 32.8048 5.38189 33.6684 6.44816 33.6684H34.4581C35.525 33.6684 36.389 32.8048 36.389 31.7369V6.62903C36.3891 5.5622 35.525 4.69849 34.4581 4.69849Z"
                  fill="#8B9AB0"
                />
              </svg>
              <span>{{ item.floor }}/{{ item.floors }} этаж</span>
            </div>
            <div v-if="item.bedroom" class="characteristics-item">
              <svg
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M18.0123 16.6251V11.4792H15.2415C13.7152 11.4792 12.6899 11.4818 11.9251 11.5846C11.1944 11.6828 10.8817 11.8526 10.6754 12.0589C10.4691 12.2653 10.2993 12.578 10.201 13.3086C10.0982 14.0734 10.0957 15.0987 10.0957 16.6251H18.0123Z"
                  fill="#8B9AB0"
                />
                <path
                  d="M28.3044 16.6251C28.3044 15.0987 28.3018 14.0734 28.1991 13.3086C28.1009 12.578 27.931 12.2653 27.7247 12.0589C27.5184 11.8526 27.2057 11.6828 26.475 11.5846C25.7102 11.4818 24.6849 11.4792 23.1585 11.4792H20.3877V16.6251H28.3044Z"
                  fill="#8B9AB0"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M20.7839 6.33337H17.6172C11.6461 6.33337 8.66054 6.33337 6.80555 8.18836C5.18664 9.80727 4.9806 12.2873 4.95438 16.8616V19.422C4.35218 19.7686 3.87702 20.306 3.60823 20.9548C3.36719 21.5369 3.36719 22.2745 3.36719 23.75C3.36719 25.2255 3.36719 25.9632 3.60823 26.5453C3.92964 27.3211 4.54611 27.9376 5.32202 28.2591C5.72164 28.4245 6.19472 28.4764 6.92969 28.4926V31.6667C6.92969 32.3225 7.46136 32.8542 8.11719 32.8542C8.77302 32.8542 9.30469 32.3225 9.30469 31.6667V28.5H29.0964V31.6667C29.0964 32.3225 29.628 32.8542 30.2839 32.8542C30.9397 32.8542 31.4714 32.3225 31.4714 31.6667V28.4926C32.2063 28.4764 32.6794 28.4245 33.0791 28.2591C33.8549 27.9376 34.4715 27.3211 34.7929 26.5453C35.0339 25.9632 35.0339 25.2255 35.0339 23.75C35.0339 22.2745 35.0339 21.5369 34.7929 20.9548C34.524 20.306 34.0489 19.7686 33.4467 19.4222V16.8616C33.4206 12.2873 33.2145 9.80727 31.5956 8.18836C29.7406 6.33337 26.7551 6.33337 20.7839 6.33337ZM30.6797 19.0002V16.5427C30.6798 15.1202 30.6798 13.9338 30.5532 12.9921C30.4195 11.9981 30.1255 11.1007 29.4045 10.3795C28.6833 9.65836 27.7858 9.36438 26.7918 9.23073C25.85 9.10413 24.6638 9.10416 23.2412 9.10421H15.1599C13.7373 9.10416 12.551 9.10413 11.6093 9.23073C10.6153 9.36438 9.71786 9.65836 8.99671 10.3795C8.27555 11.1007 7.98156 11.9981 7.84793 12.9921C7.72131 13.9338 7.72135 15.1201 7.7214 16.5427V19.0002C7.84717 19 7.97895 19 8.11719 19H30.2839C30.4221 19 30.554 19 30.6797 19.0002Z"
                  fill="#8B9AB0"
                />
              </svg>
              <span>{{ item.bedroom }} спальни</span>
            </div>
            <div v-if="item.wc" class="characteristics-item">
              <svg
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M34.0501 15.8326H11.8835V11.2615C11.8835 9.68293 12.957 8.21677 14.5134 7.96027C14.968 7.88291 15.434 7.90563 15.879 8.02683C16.3239 8.14804 16.737 8.36483 17.0896 8.66207C17.4422 8.95932 17.7257 9.32989 17.9204 9.74793C18.115 10.166 18.2162 10.6214 18.2168 11.0826H21.3835C21.3827 10.198 21.1968 9.32334 20.8376 8.51491C20.4785 7.70649 19.9541 6.98219 19.2982 6.38862C18.6423 5.79506 17.8694 5.34537 17.0292 5.06848C16.1891 4.79159 15.3003 4.69364 14.42 4.78093C11.1282 5.10077 8.7168 8.05685 8.7168 11.3644V15.8326H5.55013C5.1302 15.8326 4.72748 15.9994 4.43054 16.2963C4.13361 16.5933 3.9668 16.996 3.9668 17.4159V20.5826C3.9668 24.7088 6.6173 28.219 10.3001 29.5284V34.8326H13.4668V30.0826H26.1335V34.8326H29.3001V29.5284C32.983 28.219 35.6335 24.7088 35.6335 20.5826V17.4159C35.6335 16.996 35.4667 16.5933 35.1697 16.2963C34.8728 15.9994 34.4701 15.8326 34.0501 15.8326Z"
                  fill="#8B9AB0"
                />
              </svg>
              <span>{{ item.wc }} санузла</span>
            </div>
            <div v-if="item.square" class="characteristics-item">
              <svg
                width="39"
                height="38"
                viewBox="0 0 39 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.71289 4.75C6.74538 4.75 5.15039 6.34499 5.15039 8.3125V29.6875C5.15039 31.655 6.74538 33.25 8.71289 33.25H30.0879C32.0553 33.25 33.6504 31.655 33.6504 29.6875V8.3125C33.6504 6.34499 32.0553 4.75 30.0879 4.75H8.71289ZM9.90039 10.6875C9.90039 10.0317 10.4321 9.5 11.0879 9.5H15.0462C15.7021 9.5 16.2337 10.0317 16.2337 10.6875C16.2337 11.3433 15.7021 11.875 15.0462 11.875H13.9548L16.6775 14.5978C17.1413 15.0616 17.1413 15.8134 16.6775 16.2771C16.2138 16.7409 15.4619 16.7409 14.9982 16.2771L12.2754 13.5544V14.6477C12.2754 15.3035 11.7437 15.8352 11.0879 15.8352C10.4321 15.8352 9.90039 15.3035 9.90039 14.6477V10.6875ZM28.5533 28.1539C28.3307 28.3767 28.0286 28.5017 27.7137 28.5017H23.7553C23.0995 28.5017 22.5678 27.9701 22.5678 27.3142C22.5678 26.6584 23.0995 26.1267 23.7553 26.1267H24.8471L22.1229 23.4021C21.6592 22.9384 21.6593 22.1865 22.1231 21.7227C22.5868 21.2591 23.3388 21.2591 23.8025 21.7229L26.5262 24.447V23.354C26.5262 22.6982 27.0579 22.1665 27.7137 22.1665C28.3695 22.1665 28.9012 22.6982 28.9012 23.354V27.3142C28.9012 27.6292 28.7761 27.9313 28.5533 28.1539ZM28.9012 10.6885V14.6468C28.9012 15.3026 28.3695 15.8343 27.7137 15.8343C27.0579 15.8343 26.5262 15.3026 26.5262 14.6468V13.5545L23.8022 16.2773C23.3383 16.7411 22.5865 16.7409 22.1228 16.277C21.6592 15.8132 21.6593 15.0613 22.1232 14.5976L24.8459 11.876H23.7534C23.0976 11.876 22.5659 11.3443 22.5659 10.6885C22.5659 10.0326 23.0976 9.50097 23.7534 9.50097H27.7137C28.0286 9.50097 28.3307 9.62608 28.5533 9.84878C28.7761 10.0715 28.9012 10.3735 28.9012 10.6885ZM10.2482 28.1529C10.0255 27.9303 9.90039 27.6282 9.90039 27.3133V23.355C9.90039 22.6991 10.4321 22.1675 11.0879 22.1675C11.7437 22.1675 12.2754 22.6991 12.2754 23.355V24.446L14.9981 21.7229C15.4618 21.2591 16.2137 21.2591 16.6775 21.7227C17.1413 22.1865 17.1413 22.9384 16.6777 23.4021L13.9544 26.1258H15.048C15.7039 26.1258 16.2356 26.6575 16.2356 27.3133C16.2356 27.9691 15.7039 28.5008 15.048 28.5008H11.0879C10.773 28.5008 10.4709 28.3757 10.2482 28.1529Z"
                  fill="#8B9AB0"
                />
              </svg>
              <span>{{ item.square }} м²</span>
            </div>
            <div v-if="item.otc" class="characteristics-item">
              <svg
                width="38"
                height="38"
                viewBox="0 0 38 38"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M15.0413 30.875V28.5H7.12467C6.25384 28.5 5.46217 28.1516 4.89217 27.5658C4.30634 26.9958 3.95801 26.2041 3.95801 25.3333C3.95801 23.7025 5.22467 22.3408 6.82384 22.1825C6.91884 22.1666 7.01384 22.1666 7.12467 22.1666H30.8747C30.9855 22.1666 31.0805 22.1666 31.1755 22.1825C31.9355 22.2458 32.6005 22.5783 33.1072 23.1008C33.7563 23.7341 34.1047 24.6366 34.0255 25.6183C33.883 27.2808 32.3788 28.5 30.7005 28.5H22.958V30.875C22.958 33.06 21.1847 34.8333 18.9997 34.8333C16.8147 34.8333 15.0413 33.06 15.0413 30.875Z"
                  fill="#8B9AB0"
                />
                <path
                  d="M27.2189 3.16663H20.9806C20.5373 3.16663 20.1889 3.51496 20.1889 3.95829V6.33329C20.1889 6.98246 19.6506 7.52079 19.0014 7.52079C18.8589 7.52079 18.7323 7.48913 18.6056 7.44163C18.1464 7.28329 17.8139 6.83996 17.8139 6.33329V3.95829C17.8139 3.51496 17.4656 3.16663 17.0223 3.16663H14.6314C14.1881 3.16663 13.8397 3.51496 13.8397 3.95829V11.0833C13.8397 11.7325 13.3014 12.2708 12.6522 12.2708C12.0031 12.2708 11.4647 11.7325 11.4647 11.0833V7.52079V3.95829C11.4647 3.53079 11.1481 3.19829 10.7206 3.16663H10.6731C7.91807 3.22996 5.78057 5.62079 6.06557 8.39163L6.6514 19.0791C6.6989 19.9183 7.39557 20.5833 8.23473 20.5833H29.7681C30.6073 20.5833 31.3039 19.9183 31.3514 19.0791L31.9373 8.39163C32.2223 5.58913 30.0214 3.16663 27.2189 3.16663Z"
                  fill="#8B9AB0"
                />
              </svg>
              <span>{{ item.otc || "без отделки" }}</span>
            </div>
          </div>
        </div>
      </section>
      <section class="photos">
        <div class="photos-container">
          <div
            class="row"
            v-for="(rowPhotos, rowIndex) in chunkedPhotos"
            :key="rowIndex"
          >
            <div
              v-for="(photo, photoIndex) in rowPhotos"
              :key="photoIndex"
              :class="['photo-wrapper', getSizeClass(rowIndex, photoIndex)]"
            >
              <img :src="photo" alt="" />
            </div>
          </div>
        </div>
      </section>
      <section class="photos__mobile">
        <div class="swiper-container">
          <swiper
            :modules="[Pagination]"
            :slides-per-view="1.2"
            :space-between="10"
            :centeredSlides="false"
            :loop="false"
            :pagination="{ el: '.swiper-pagination', clickable: true }"
          >
            <swiper-slide
              class="photos__slide"
              v-for="(photo, index) in item.photos"
              :key="index"
            >
              <img :src="photo" alt="" style="width: 100%; display: block" />
            </swiper-slide>
            <!-- элемент пагинации -->
          </swiper>
          <div class="swiper-pagination"></div>
        </div>
      </section>
      <!-- <section id="apartments" class="apartments">
        <div class="title__section">
          <h2 class="title">Квартира</h2>
          <div class="title__section-line"></div>
        </div>
        <div class="apartments__information">
          <div class="apartments__information-plan">
            <img :src="item.photos[1]" class="plan" alt="План апартаментов" />
          </div>
          <div class="apartments__details">
            <div class="apartments__details-title">
              <h3>{{ item.address }}</h3>
            </div>
            <div class="apartments__icon-list">
              <div class="apartments__icon-item">
                <img
                  src="https://spa-bitrix.ru/masthev_selections/img/ico_area.png"
                  class="apartments__icon"
                  alt=""
                />
                <span class="apartments__icon-description"
                  >Общая площадь: <strong>{{ item.square }}</strong></span
                >
              </div>
              <div class="apartments__icon-item">
                <img
                  src="https://spa-bitrix.ru/masthev_selections/img/ico_floor.png"
                  class="apartments__icon"
                  alt=""
                />
                <span class="apartments__icon-description"
                  >Этажность: <strong>{{ item.floor }}</strong></span
                >
              </div>
              <div class="apartments__icon-item">
                <img
                  src="https://spa-bitrix.ru/masthev_selections/img/ico_bedroom.png"
                  class="apartments__icon"
                  alt=""
                />
                <span class="apartments__icon-description"
                  >Количество спален: <strong>{{ item.rooms }}</strong></span
                >
              </div>
              <div class="apartments__icon-item">
                <img
                  src="https://spa-bitrix.ru/masthev_selections/img/otd.png"
                  class="apartments__icon"
                  alt=""
                />
                <span class="apartments__icon-description"
                  >Тип отделки: <strong>{{ item.otc }}</strong></span
                >
              </div>
            </div>
          </div>
        </div>
      </section> -->
      <!-- <section id="object" class="object">
        <div class="title__section">
          <h2 class="title">Дополнительно</h2>
          <div class="title__section-line"></div>
        </div>
        <div class="object__gallery">
          <v-carousel
            cycle
            cover
            draggable
            transition
            hide-delimiter-background
            style="overflow: visible"
          >
            <v-carousel-item
              class="object__gallery-item"
              v-for="(slide, i) in item.photos.filter(
                (e, index) => index !== 0 || index !== 1
              )"
              :key="i"
              :src="slide"
            >
            </v-carousel-item>
          </v-carousel>
        </div>
        <div class="object__information">
          <div class="object__information-line"></div>
          <div class="object__information-description">
            <p>
              {{ item.discriptions }}
            </p>
          </div>
          <div class="object__information-line"></div>
        </div>
      </section> -->
      <section class="object__map mb-5">
        <div class="location__con">
          <h2 class="title">Локация</h2>
          <div
            class="map-container"
            style="width: 100%; border-radius: 12px; overflow: hidden"
          >
            <yandex-map
              v-if="modelValue == true"
              :key="item.id"
              cursor-grab
              :settings="{
                location: {
                  center: item.coordinates,
                  zoom: 15,
                },
              }"
              width="100%"
              height="55vh"
            >
              <yandex-map-default-scheme-layer />
              <yandex-map-default-features-layer />
              <yandex-map-controls :settings="{ position: 'top left' }">
              </yandex-map-controls>
              <yandex-map-controls
                :settings="{ position: 'bottom left', orientation: 'vertical' }"
              >
              </yandex-map-controls>
              <yandex-map-controls :settings="{ position: 'right' }">
                <yandex-map-zoom-control />
              </yandex-map-controls>
              <YandexMapMarker
                :marker-id="item.id"
                :settings="{
                  position: 'top left-center',
                  coordinates: item.coordinates,
                  properties: { item },
                }"
              >
                <div class="marker__container">
                  <div class="clip">
                    {{ `${item.mapPrice} ${item.currency}` }}
                  </div>
                  <div class="marker" />
                </div>
              </YandexMapMarker>
            </yandex-map>
          </div>
        </div>
      </section>
      <!-- <section id="contacts" class="contacts">
        <div class="title__section">
          <h2 class="title">Контакты</h2>
          <div class="title__section-line"></div>
        </div>
        <div class="contact__information">
          <div class="contact__details">
            <div class="contacts__title">
              <span>Контакты</span>
            </div>
            <div class="contacts__phone">
              <span class="contacts__sub-name">{{ item.assigned.name }}</span>
              <div class="contacts__phone-details">
                <div class="icon__phone">
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M8.40894 3.94106C7.73727 3.44593 7.28496 3.33414 7.04226 3.38151C6.04101 3.57691 5.44749 3.96667 4.64337 4.77079C3.54575 5.86839 3.01318 6.68796 3.24513 7.93058C3.51219 9.36125 4.81689 11.5448 8.41291 15.1408C12.0087 18.7366 14.2054 20.055 15.6441 20.3277C16.3108 20.4541 16.8185 20.3553 17.2741 20.1309C17.7612 19.891 18.2302 19.4872 18.7681 18.9257C19.2452 18.4279 19.5347 18.0804 19.7373 17.7385C19.9303 17.4128 20.0671 17.0527 20.1728 16.5118C20.2202 16.2691 20.1084 15.8168 19.6132 15.145C19.1513 14.5185 18.4997 13.8963 17.8973 13.3883C17.4998 13.0532 16.8848 13.0318 16.388 13.4037L14.8697 14.5403C13.5001 15.5656 11.5864 15.4187 10.3781 14.2104L9.34333 13.1757C8.13502 11.9674 7.98816 10.0536 9.0134 8.68408L10.15 7.1658C10.5219 6.66899 10.5005 6.05399 10.1653 5.65648C9.65746 5.05422 9.03533 4.4028 8.40894 3.94106ZM9.59567 2.33119C10.4051 2.92787 11.1441 3.71475 11.6943 4.36717C12.6971 5.55639 12.6153 7.20989 11.7511 8.36437L10.6145 9.88265C10.191 10.4483 10.2458 11.2497 10.7575 11.7614L11.7923 12.7962C12.3041 13.308 13.1054 13.3627 13.6711 12.9393L15.1894 11.8026C16.3439 10.9384 17.9973 10.8566 19.1865 11.8593C19.8391 12.4095 20.6262 13.1486 21.223 13.9582C21.7864 14.7224 22.3533 15.7809 22.1357 16.8952C21.9959 17.6108 21.7906 18.1964 21.4579 18.758C21.1348 19.3034 20.715 19.7847 20.2122 20.3094C19.6296 20.9175 18.9653 21.5274 18.1578 21.9251C17.3189 22.3383 16.3708 22.501 15.2716 22.2927C13.1786 21.896 10.6038 20.1601 6.99869 16.555C3.39388 12.9502 1.66901 10.3864 1.27909 8.29757C0.854079 6.02068 2.03716 4.54855 3.22916 3.35656C4.21375 2.37199 5.14736 1.71358 6.65918 1.41854C7.7733 1.20111 8.83152 1.76789 9.59567 2.33119Z"
                      fill="#263C44"
                    />
                  </svg>
                </div>
                <a href="tel:+79255024106">{{ item.assigned.phone }}</a>
              </div>
            </div>
            <div class="contacts__time">
              <div class="icon__time">
                <svg
                  width="25"
                  height="24"
                  viewBox="0 0 25 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.6335 12.0001C22.6335 10.6869 22.3749 9.38654 21.8723 8.17329C21.3698 6.96003 20.6332 5.85764 19.7046 4.92905C17.8292 3.05369 15.2857 2.00012 12.6335 2.00012C9.98138 2.00012 7.43784 3.05369 5.56248 4.92905C4.63389 5.85764 3.8973 6.96003 3.39475 8.17329C2.8922 9.38654 2.63355 10.6869 2.63355 12.0001C2.63355 14.6523 3.68711 17.1958 5.56248 19.0712C7.43784 20.9466 9.98138 22.0001 12.6335 22.0001C13.9468 22.0001 15.2471 21.7415 16.4604 21.2389C17.6736 20.7364 18.776 19.9998 19.7046 19.0712C20.6332 18.1426 21.3698 17.0402 21.8723 15.827C22.3749 14.6137 22.6335 13.3133 22.6335 12.0001ZM8.43355 16.2001L11.6335 11.0001L17.6335 11.0001L17.6335 12.5001L12.4335 12.5001L9.73355 17.0001L8.43355 16.2001Z"
                    fill="#263C44"
                  />
                </svg>
              </div>
              <span class="contacts__sub-name">
                Время работы: с 10:00 до 19:00
              </span>
            </div>
          </div>
          <div class="contact__form">
           
          </div>
        </div>
      </section>-->
    </main>
    <footer>
      <div class="footer-section">
        <div style="display: flex; justify-content: center">
          <svg
            width="92"
            height="61"
            viewBox="0 0 92 61"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M20.4519 10.082C19.2157 10.8168 17.8387 11.8015 16.3556 13.0717C15.5604 11.3842 14.8972 9.31956 14.4131 7.13302C17.0286 3.74996 19.3203 2.39136 19.3203 2.39136C19.3501 4.07278 19.6253 7.06889 20.4519 10.082Z"
              fill="#EC4900"
            />
            <path
              d="M20.4519 10.082C19.2157 10.8168 17.8387 11.8015 16.3556 13.0717C15.5604 11.3842 14.8972 9.31956 14.4131 7.13302C17.0286 3.74996 19.3203 2.39136 19.3203 2.39136C19.3501 4.07278 19.6253 7.06889 20.4519 10.082Z"
              fill="url(#paint0_linear_846_680)"
            />
            <path
              d="M19.195 10.4462C18.5235 8.44857 18.2238 6.44141 18.1397 5.30981C18.1397 5.30981 16.6481 6.31233 15.0156 8.69022L16.0482 12.5076L19.2748 11.2336"
              fill="url(#paint1_linear_846_680)"
            />
            <path
              d="M29.9999 60.1947C29.679 60.1947 29.3583 60.191 29.0453 60.1833C-0.169037 59.5222 -4.07292 29.9872 6.12764 17.0654C8.80253 13.6794 7.08252 5.83281 15.3387 0C15.1995 1.56938 15.1841 3.22764 15.2847 4.83162C15.4007 6.7797 15.6868 8.65061 16.139 10.216C17.5923 9.32685 18.9182 8.66604 20.0817 8.2059C22.0492 7.41363 23.572 7.17012 24.5423 7.23186C25.7136 7.31303 26.9466 8.42626 28.8869 8.89784C32.9726 8.2059 36.2388 7.02321 40.3591 4.94739C44.2515 15.6001 34.0238 21.6418 25.4467 32.0973C18.1025 41.0652 17.3331 54.331 29.9999 60.1947Z"
              fill="url(#paint2_linear_846_680)"
            />
            <path
              d="M29.0453 60.1833L26.5243 60.0858C25.6865 60.0145 24.8508 59.9083 24.013 59.821C23.1811 59.6938 22.3545 59.5275 21.5239 59.3822C20.7071 59.1759 19.8867 58.975 19.0752 58.7448C15.851 57.7455 12.7937 56.1671 10.1505 54.0409C8.86189 52.9445 7.61746 51.7748 6.587 50.4237C6.03105 49.7804 5.58342 49.0571 5.09453 48.3638C4.86433 48.008 4.66127 47.6346 4.44357 47.2708L4.12209 46.7215C4.01909 46.5363 3.9318 46.3425 3.83573 46.1536L3.2726 45.0124L2.78877 43.8359C2.70999 43.6389 2.62377 43.4449 2.55138 43.2458L2.34938 42.6428C2.21871 42.2396 2.07128 41.8412 1.95445 41.4337C1.74207 40.613 1.49909 39.7989 1.35645 38.9622L1.2327 38.3384L1.17122 38.0265L1.12837 37.7114L0.957251 36.451C0.610481 33.0796 0.787191 29.6468 1.5768 26.3475C1.97068 24.7005 2.48458 23.0749 3.19968 21.5348C3.90679 19.9958 4.73526 18.498 5.79952 17.1697C6.86138 15.9008 7.24195 14.2319 7.65366 12.6146C8.05232 10.9848 8.45232 9.33588 9.07932 7.76197C9.70313 6.1894 10.5505 4.70306 11.6121 3.3889C12.1457 2.73422 12.7328 2.12584 13.3539 1.55711C13.9772 0.989189 14.6524 0.484604 15.339 0.000244141C13.9868 0.998504 12.7509 2.15405 11.7228 3.47645C10.7019 4.80392 9.90167 6.28973 9.32283 7.85592C8.73042 9.41971 8.35544 11.054 7.98073 12.6929C7.79098 13.5123 7.59431 14.3354 7.32205 15.1445C7.18101 15.5471 7.02904 15.9495 6.82545 16.3327C6.73257 16.5278 6.61281 16.7117 6.49705 16.8959L6.1242 17.4188L5.39819 18.4333L4.75096 19.5002L4.58888 19.7666L4.44437 20.0431L4.15775 20.5975L3.87086 21.1519C3.78144 21.3397 3.70373 21.533 3.61936 21.7232C2.92476 23.2373 2.42763 24.8372 2.04839 26.458C1.28699 29.7045 1.13157 33.0825 1.48552 36.3929L1.64786 37.6318L1.68831 37.9416L1.7474 38.2481L1.86609 38.8616C2.00182 39.6847 2.23708 40.4847 2.44147 41.2922C2.55404 41.693 2.69749 42.0844 2.82363 42.4812L3.01897 43.0745C3.08897 43.2703 3.17306 43.4611 3.24944 43.6546L3.7189 44.8123L4.26633 45.9348C4.35948 46.1209 4.44411 46.3117 4.54444 46.494L4.85741 47.0342C5.06952 47.3922 5.26672 47.7597 5.49107 48.1102C5.96798 48.792 6.40337 49.505 6.94628 50.1381C7.95545 51.4653 9.15996 52.6278 10.4097 53.7272C12.9779 55.8554 15.9729 57.4559 19.1529 58.4976C22.334 59.5581 25.6899 60.0345 29.0453 60.1833Z"
              fill="url(#paint3_linear_846_680)"
            />
            <path
              d="M30.0004 60.1948C0.535089 56.9829 3.29886 24.8464 15.7645 18.9247C14.0878 18.6299 10.9954 18.6626 10.9954 18.6626C15.2061 13.794 35.0755 13.7283 40.3593 4.94751C44.2517 15.6002 34.024 21.6419 25.4469 32.0975C18.103 41.0653 17.3336 54.3312 30.0004 60.1948Z"
              fill="url(#paint4_linear_846_680)"
            />
            <path
              d="M30.2551 23.7987C28.1638 25.9866 26.0071 28.2477 23.8927 30.8259C19.1654 36.593 17.1824 43.6897 18.5818 49.8046C19.204 52.5064 20.4372 54.9183 22.2384 56.9824C16.0152 54.8874 11.1876 44.5671 12.7298 35.9319C11.6783 37.5553 10.8049 39.3219 10.2058 41.1617C7.96764 18.7273 34.967 17.444 39.0566 7.80396C39.9843 13.262 36.3354 17.4326 30.2551 23.7987Z"
              fill="url(#paint5_linear_846_680)"
            />
            <path
              d="M30.255 23.7987C28.1637 25.9866 26.007 28.2477 23.8926 30.8259C19.1653 36.593 17.1823 43.6897 18.5816 49.8046C19.2039 52.5064 20.4371 54.9183 22.2383 56.9824C12.7914 49.6768 15.0157 35.1107 20.4515 28.2024C18.8744 28.5965 16.2652 30.385 16.2652 30.385C20.4515 21.2284 39.1996 17.0653 39.0565 7.80396C39.9842 13.262 36.3353 17.4326 30.255 23.7987Z"
              fill="url(#paint6_linear_846_680)"
            />
            <path
              d="M12.73 35.9324C11.7203 37.5894 10.8791 39.3501 10.3157 41.1978L10.1531 41.7312L10.0911 41.1736C9.98194 40.1943 9.921 39.2085 9.92393 38.2206C9.93351 37.233 9.99924 36.2446 10.1355 35.2636C10.4123 33.3028 10.9956 31.376 11.8962 29.6028C12.788 27.825 13.9771 26.2053 15.3453 24.7711C16.0287 24.0526 16.7558 23.3771 17.5127 22.7397C18.2733 22.1064 19.0653 21.5131 19.8751 20.9489C23.1241 18.6964 26.6405 16.9085 30.1028 15.0784C31.8298 14.1541 33.5394 13.1949 35.1372 12.0713C35.9306 11.5042 36.6976 10.8937 37.3754 10.1911C37.7179 9.84301 38.0256 9.46324 38.3167 9.07096C38.5993 8.6723 38.8474 8.24915 39.056 7.80444C38.8695 8.25846 38.6411 8.69572 38.3758 9.11115C38.1017 9.52019 37.8009 9.91301 37.4688 10.2781C36.8093 11.0132 36.0567 11.6586 35.2759 12.2603C33.7012 13.4512 31.9918 14.4396 30.2841 15.4089L25.1387 18.2642C23.4357 19.2295 21.7609 20.2418 20.1684 21.3676C19.3721 21.9302 18.598 22.5221 17.8531 23.1472C17.1047 23.7681 16.3872 24.4252 15.7131 25.1235C14.3638 26.5178 13.1936 28.0885 12.3119 29.8143C11.4326 31.5397 10.8227 33.402 10.5046 35.3201C10.3497 36.2797 10.2638 37.2511 10.2326 38.2251C10.2068 39.2 10.2531 40.1754 10.3202 41.1505L10.0956 41.1263C10.7372 39.2817 11.6317 37.5332 12.73 35.9324Z"
              fill="url(#paint7_linear_846_680)"
            />
            <path
              d="M30 60.1947C27.6205 59.9762 25.2498 59.5518 22.9581 58.8343C20.6646 58.1274 18.4637 57.1002 16.4491 55.7769C15.4415 55.1153 14.4906 54.3654 13.6063 53.5436C12.7262 52.717 11.9142 51.8166 11.1842 50.8538C9.72206 48.9288 8.59473 46.7538 7.83147 44.4613C7.05995 42.1694 6.67379 39.7566 6.61578 37.3452C6.55856 34.9325 6.834 32.5125 7.44824 30.1791C8.06087 27.8478 9.02666 25.5979 10.3845 23.6011C11.7271 21.607 13.528 19.8606 15.7273 18.8483L15.7489 19.0074C14.9718 18.8661 14.176 18.8027 13.3824 18.7535C12.5878 18.7064 11.7915 18.6737 10.9947 18.6622C11.7915 18.6425 12.5891 18.6364 13.3867 18.6588C14.1843 18.6838 14.9822 18.7218 15.7784 18.8413L16.0379 18.8802L15.8 19.0005C14.7418 19.5359 13.7705 20.2335 12.9212 21.0574C12.0624 21.8715 11.3133 22.7979 10.669 23.7906C9.36598 25.7719 8.48535 28.005 7.89188 30.2935C6.71557 34.8827 6.86274 39.8035 8.32221 44.2987C9.0546 46.5451 10.1434 48.6773 11.5616 50.5687C12.2697 51.5148 13.0586 52.4005 13.9155 53.2154C14.7693 54.0332 15.6861 54.7891 16.6652 55.4573C18.6199 56.7994 20.7788 57.8432 23.0332 58.6049C25.2828 59.3926 27.6335 59.8669 30 60.1947Z"
              fill="url(#paint8_linear_846_680)"
            />
            <path
              d="M46.9967 49.2377H45.6252C45.0633 49.2377 44.6062 49.0663 44.2538 48.7234C43.9014 48.371 43.7252 47.871 43.7252 47.2234V29.7234L43.9109 29.5377H45.1395C45.8062 29.5377 46.2824 29.7091 46.5681 30.052C46.8538 30.3853 46.9967 30.9139 46.9967 31.6377V49.2377ZM55.1252 46.3948C55.1252 47.4805 54.9538 48.2282 54.6109 48.6377C54.2776 49.0377 53.7157 49.2377 52.9252 49.2377H45.6252L43.9252 46.8377C44.8586 46.6853 45.8252 46.5758 46.8252 46.5091C47.8252 46.4329 48.7347 46.3948 49.5538 46.3948H55.1252ZM61.3654 49.1948C60.9083 49.2805 60.3797 49.3234 59.7797 49.3234C59.1797 49.3234 58.6511 49.2805 58.194 49.1948V38.8663C58.194 38.371 58.1035 37.9996 57.9225 37.752C57.7416 37.4948 57.413 37.3663 56.9368 37.3663H56.594C56.5083 37.0043 56.4654 36.6329 56.4654 36.252C56.4654 36.071 56.4749 35.8853 56.494 35.6948C56.513 35.4948 56.5464 35.2948 56.594 35.0948C56.9654 35.0472 57.3225 35.0139 57.6654 34.9948C58.0083 34.9758 58.2892 34.9663 58.5083 34.9663H58.9368C59.6892 34.9663 60.2797 35.2043 60.7083 35.6805C61.1464 36.1567 61.3654 36.8091 61.3654 37.6377V49.1948ZM57.3083 31.2234C57.3083 30.7282 57.3987 30.2853 57.5797 29.8948C57.7702 29.7901 58.0178 29.7043 58.3225 29.6377C58.6368 29.5615 58.9416 29.5234 59.2368 29.5234C59.513 29.5234 59.8178 29.5615 60.1511 29.6377C60.4844 29.7043 60.7321 29.7901 60.894 29.8948C60.9702 30.0758 61.0321 30.2901 61.0797 30.5377C61.1368 30.7853 61.1654 31.0139 61.1654 31.2234C61.1654 31.7186 61.0749 32.1663 60.894 32.5663C60.7416 32.671 60.494 32.7567 60.1511 32.8234C59.8178 32.8901 59.513 32.9234 59.2368 32.9234C58.9416 32.9234 58.6321 32.8901 58.3083 32.8234C57.994 32.7567 57.7511 32.671 57.5797 32.5663C57.3987 32.1663 57.3083 31.7186 57.3083 31.2234ZM64.3051 48.1663C64.3242 47.8043 64.4337 47.4091 64.6337 46.9805C64.8337 46.5424 65.0623 46.1996 65.3194 45.952C65.9289 46.2758 66.5766 46.5663 67.2623 46.8234C67.948 47.0805 68.6385 47.2091 69.3337 47.2091C70.0766 47.2091 70.6623 47.052 71.0908 46.7377C71.5289 46.4234 71.748 46.0234 71.748 45.5377C71.748 45.1567 71.6051 44.8091 71.3194 44.4948C71.0337 44.171 70.6051 43.9043 70.0337 43.6948L68.3766 43.0805C67.7194 42.8424 67.1147 42.5424 66.5623 42.1805C66.0194 41.8186 65.5813 41.3758 65.248 40.852C64.9242 40.3282 64.7623 39.7043 64.7623 38.9805C64.7623 38.0948 64.9813 37.3329 65.4194 36.6948C65.867 36.0472 66.4766 35.552 67.248 35.2091C68.0289 34.8567 68.9099 34.6805 69.8908 34.6805C70.6813 34.6805 71.5194 34.7901 72.4051 35.0091C73.3004 35.2186 74.0432 35.4615 74.6337 35.7377C74.6528 36.1282 74.5718 36.552 74.3908 37.0091C74.2194 37.4663 73.9956 37.8091 73.7194 38.0377C73.2051 37.8091 72.6099 37.5948 71.9337 37.3948C71.267 37.1853 70.5813 37.0805 69.8766 37.0805C69.2956 37.0805 68.8289 37.2234 68.4766 37.5091C68.1242 37.7948 67.948 38.171 67.948 38.6377C67.948 39.0091 68.0861 39.3234 68.3623 39.5805C68.6385 39.8282 69.0575 40.0567 69.6194 40.2663L71.3766 40.9234C72.4528 41.3043 73.3289 41.8424 74.0051 42.5377C74.6908 43.2329 75.0337 44.1424 75.0337 45.2663C75.0337 46.5996 74.5147 47.652 73.4766 48.4234C72.4385 49.1948 71.0623 49.5805 69.348 49.5805C68.3385 49.5805 67.4004 49.4377 66.5337 49.152C65.6766 48.8663 64.9337 48.5377 64.3051 48.1663ZM76.833 48.1663C76.8521 47.8043 76.9616 47.4091 77.1616 46.9805C77.3616 46.5424 77.5902 46.1996 77.8473 45.952C78.4568 46.2758 79.1045 46.5663 79.7902 46.8234C80.4759 47.0805 81.1664 47.2091 81.8616 47.2091C82.6045 47.2091 83.1902 47.052 83.6187 46.7377C84.0568 46.4234 84.2759 46.0234 84.2759 45.5377C84.2759 45.1567 84.133 44.8091 83.8473 44.4948C83.5616 44.171 83.133 43.9043 82.5616 43.6948L80.9045 43.0805C80.2473 42.8424 79.6426 42.5424 79.0902 42.1805C78.5473 41.8186 78.1092 41.3758 77.7759 40.852C77.4521 40.3282 77.2902 39.7043 77.2902 38.9805C77.2902 38.0948 77.5092 37.3329 77.9473 36.6948C78.3949 36.0472 79.0045 35.552 79.7759 35.2091C80.5568 34.8567 81.4378 34.6805 82.4187 34.6805C83.2092 34.6805 84.0473 34.7901 84.933 35.0091C85.8283 35.2186 86.5711 35.4615 87.1616 35.7377C87.1807 36.1282 87.0997 36.552 86.9187 37.0091C86.7473 37.4663 86.5235 37.8091 86.2473 38.0377C85.733 37.8091 85.1378 37.5948 84.4616 37.3948C83.7949 37.1853 83.1092 37.0805 82.4045 37.0805C81.8235 37.0805 81.3568 37.2234 81.0045 37.5091C80.6521 37.7948 80.4759 38.171 80.4759 38.6377C80.4759 39.0091 80.614 39.3234 80.8902 39.5805C81.1664 39.8282 81.5854 40.0567 82.1473 40.2663L83.9045 40.9234C84.9807 41.3043 85.8568 41.8424 86.533 42.5377C87.2187 43.2329 87.5616 44.1424 87.5616 45.2663C87.5616 46.5996 87.0426 47.652 86.0045 48.4234C84.9664 49.1948 83.5902 49.5805 81.8759 49.5805C80.8664 49.5805 79.9283 49.4377 79.0616 49.152C78.2045 48.8663 77.4616 48.5377 76.833 48.1663Z"
              fill="black"
            />
            <defs>
              <linearGradient
                id="paint0_linear_846_680"
                x1="17.2779"
                y1="-1.58997"
                x2="17.472"
                y2="11.2207"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.1843" stop-color="#EE5E1F" />
                <stop offset="0.5478" stop-color="#C34712" />
                <stop offset="1" stop-color="#852800" />
              </linearGradient>
              <linearGradient
                id="paint1_linear_846_680"
                x1="17.3547"
                y1="4.82987"
                x2="17.1573"
                y2="9.66564"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.495" stop-color="#EEEEEE" />
                <stop offset="1" stop-color="#C3C3C3" />
              </linearGradient>
              <linearGradient
                id="paint2_linear_846_680"
                x1="19.069"
                y1="-0.346876"
                x2="24.7462"
                y2="60.6834"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF8351" />
                <stop offset="0.595" stop-color="#EE5C1D" />
                <stop offset="1" stop-color="#C3440B" />
              </linearGradient>
              <linearGradient
                id="paint3_linear_846_680"
                x1="10.5261"
                y1="0.216183"
                x2="16.2399"
                y2="61.6399"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#A83400" />
                <stop offset="0.2731" stop-color="#C3440B" />
                <stop offset="0.7546" stop-color="#EE5C1D" />
                <stop offset="1" stop-color="#FF6624" />
              </linearGradient>
              <linearGradient
                id="paint4_linear_846_680"
                x1="23.4473"
                y1="-15.5777"
                x2="24.4528"
                y2="50.779"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.385" stop-color="#EE5E1F" />
                <stop offset="1" stop-color="#C34712" />
              </linearGradient>
              <linearGradient
                id="paint5_linear_846_680"
                x1="28.6617"
                y1="3.67053"
                x2="16.8192"
                y2="61.6992"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.2101" stop-color="#EEEEEE" />
                <stop offset="0.6219" stop-color="#C3C3C3" />
                <stop offset="1" stop-color="#969696" />
              </linearGradient>
              <linearGradient
                id="paint6_linear_846_680"
                x1="33.069"
                y1="-0.758217"
                x2="20.1407"
                y2="50.7575"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="white" />
                <stop offset="0.625" stop-color="#EEEEEE" />
                <stop offset="1" stop-color="#C3C3C3" />
              </linearGradient>
              <linearGradient
                id="paint7_linear_846_680"
                x1="23.1454"
                y1="9.15775"
                x2="26.1034"
                y2="40.9569"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.2454" stop-color="#EE5C1D" />
                <stop offset="0.7269" stop-color="#C3440B" />
                <stop offset="1" stop-color="#A83400" />
              </linearGradient>
              <linearGradient
                id="paint8_linear_846_680"
                x1="15.4132"
                y1="17.9854"
                x2="19.4552"
                y2="61.4376"
                gradientUnits="userSpaceOnUse"
              >
                <stop stop-color="#FF6624" />
                <stop offset="0.2454" stop-color="#EE5C1D" />
                <stop offset="0.7269" stop-color="#C3440B" />
                <stop offset="1" stop-color="#A83400" />
              </linearGradient>
            </defs>
          </svg>
        </div>
        <div class="footer-section__copyright">
          <span>© 2025 Liss. Все права защищены</span>
        </div>
      </div>
    </footer>
  </v-card>
</template>
<script>
import {
  YandexMap,
  YandexMapDefaultSchemeLayer,
  YandexMapDefaultFeaturesLayer,
  YandexMapZoomControl,
  YandexMapControls,
  YandexMapMarker,
} from "vue-yandex-maps";
import { Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/vue";

// Не забудьте про стили!
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
export default {
  name: "selection-vue",
  components: {
    YandexMap,
    YandexMapDefaultSchemeLayer,
    YandexMapDefaultFeaturesLayer,
    YandexMapZoomControl,
    YandexMapControls,
    YandexMapMarker,
    Swiper,
    SwiperSlide,
  },
  setup() {
    return {
      Pagination,
    };
  },
  props: {
    item: Object,
    modelValue: Boolean,
  },
  mounted() {
    const images = this.item.photos.filter(function (element, index) {
      return index !== 0 || index !== 1;
    });
    console.log({ images });
    console.log(this.item);
  },
  computed: {
    chunkedPhotos() {
      const chunkSize = 2; // по 2 фото в ряду
      const photos = this.item.photos.slice(); // создаем копию массива
      // исключаем последний элемент
      if (photos.length > 0) {
        photos.pop();
      }
      const chunks = [];
      for (let i = 0; i < photos.length; i += chunkSize) {
        chunks.push(photos.slice(i, i + chunkSize));
      }
      return chunks;
    },
  },
  methods: {
    getSizeClass(rowIndex, photoIndex) {
      // Чередование размеров:
      // В нечетных рядах: первая меньшая, вторая большая
      // В четных рядах: первая большая, вторая меньшая
      if (rowIndex % 2 === 0) {
        return photoIndex === 0 ? "small" : "large";
      } else {
        return photoIndex === 0 ? "large" : "small";
      }
    },
  },
};
</script>
<style>
.swiper-pagination {
  display: flex;
  justify-content: center;
  position: static;
  margin-top: 15px;
  /* отступ сверху */
}

/* Стиль для самих точек */
.swiper-pagination-bullet-active {
  position: relative;
  width: 8px; /* размер внутреннего круга */
  height: 8px;
  background-color: #ff6624; /* цвет внутреннего круга */
  border-radius: 50%;
  /* создаст отступ вокруг */
}

/* Псевдоэлемент с кольцом */
.swiper-pagination-bullet-active::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  width: 12px; /* внешний диаметр кольца */
  height: 12px;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  box-shadow: 0 0 0 2px #ff6624;
  box-sizing: border-box;
  /* по умолчанию псевдоэлемент будет за внутренним кругом, но это можно исправить */
}
</style>
<style scoped>
/* Общий стиль точек */
.saled {
  padding: 3px 10px;
  background-color: #ff6624;
  border-radius: 10px;
  width: max-content;
}

.saled p {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 14px;
  color: #fff;
  line-height: 40px;
  letter-spacing: 0px;
  text-align: center;
}
.description__text {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  max-width: 492px;
  color: #474849;
}
main {
  display: flex;
  flex-direction: column;
  gap: 66px;
}
.characteristics-items {
  display: flex;
  flex-wrap: wrap;
  row-gap: 20px;
  column-gap: 70px;
  align-items: center;
}
.photos {
  width: 70%;
  margin: 0 auto;
}
.object__gallery-item {
  flex: 0 0 80%; /* ширина элемента */
  max-width: 80%;
  margin-right: 10px; /* зазор */
  box-sizing: border-box;
}
.object__map {
  padding: 40px 0;
  display: flex;
  background-color: #f4f6f9;
  flex-direction: column;
  justify-content: center;
}
.location__con {
  margin: 0 auto;
  width: 70%;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.photos__mobile {
  display: none;
}
.btn__block {
  width: 323px;
}
.btn-reset {
  display: flex;

  align-items: center;
  gap: 10px;
}

.btn-reset span {
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;

  font-size: 0.92857rem !important;
  line-height: 24px;
  letter-spacing: 0px;
}
.description {
  padding: 0;
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: start;
  flex-direction: row;
  gap: 25px;
}
.description__address {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: Medium;
  font-size: 16px;
  color: #474849;
  line-height: 24px;
  letter-spacing: 0px;
}
.description__info {
  width: 45%;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.description__photo {
  width: 55%;

  height: 574px;
}
.description__photo img {
  width: 100%;
  height: 100%;
  border-radius: 16px;
  object-fit: cover;
}
.characteristics {
  display: flex;
  align-items: center;
  padding: 47px 0;
  min-height: 134px;
  background-color: #f4f6f9;
}
.characteristics-container {
  width: 70%;
  margin: 0 auto;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 30px;
  justify-content: space-between;
}
.characteristics-item {
  display: flex;
  align-items: center;
  gap: 15px;
}
.characteristics-item span {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 16px;
  line-height: 18px;
  letter-spacing: 0px;
  color: #474849;
}
.photos-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.photos__mobile {
  padding-left: 5%;
}
.photos__slide {
  width: 311px;
  height: 253px;
}
.photos__slide img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}
.row {
  display: flex;
  gap: 20px;
}

/* Размер для меньших фото */
.photo-wrapper.small {
  flex: 1;
}
.photo-wrapper {
  height: 410px;
}
/* Размер для больших фото */
.photo-wrapper.large {
  flex: 2;
}

.photo-wrapper img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 12px;
}
.price {
  color: #ff6624;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;

  font-size: 18px;

  line-height: 150%;
  letter-spacing: 0px;
  position: super;
}
.clip {
  z-index: 10 !important;
  cursor: pointer;
  bottom: 22px;
  right: -36px;
  padding: 2px;
  position: fixed !important;
  background-color: #ff8152;
  border-radius: 13px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 14px;
  position: relative;
  text-align: center;
  min-width: 120px;
}

.clip::after {
  content: url("data:image/svg+xml;charset=UTF-8,%3csvg width='60' height='12' viewBox='0 0 60 12' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath fill-rule='evenodd' clip-rule='evenodd' d='M59.3047 0H0.74414C1.58674 0.199128 2.46227 0.314337 3.36157 0.336229L17.7819 0.687281C23.6216 0.829443 28.6091 4.94152 29.8619 10.647C29.9967 11.2607 30.8624 11.2863 31.0331 10.6816L31.0768 10.5267C32.688 4.81974 37.8274 0.826804 43.7555 0.676281L56.6451 0.348997C57.5595 0.32578 58.4493 0.206156 59.3047 0Z' fill='%23FF8351'/%3e%3c/svg%3e ");
  position: fixed;
  bottom: 3px;
  right: 25px;
  display: grid;
  justify-items: center;
  width: 100%;
}

.clip span {
  color: white;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 23px;
  padding: 0 10px;
  width: 100%;
}
.cluster__marker {
  z-index: -1 !important;
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 25px;
  height: 25px;
  color: #fff;
  background-color: #ff8152;
}
.marker {
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.25);
  border-radius: 40px;
  border: 2px white solid;
  width: 12px;
  height: 12px;
  background-color: #ff8152;
}

.marker span {
  font-size: 10px;
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  width: 21px;
  height: 21px;
  display: grid;
  justify-items: center;
  align-items: center;
}

img {
  max-width: 100%;
}

.list-reset {
  margin: 0;
  padding: 0;
  list-style: none;
}

header {
  position: absolute;
  width: 100%;
}
.header-container {
  width: 70%;
  display: flex;
  margin: 0 auto;
  justify-content: space-between;
  align-items: center;
  padding: 1.78571rem 0;
}

.nav__list {
  display: flex;
  gap: 40px;
  list-style: none;
  width: 323px;
}

.navbar__link {
  font-family: "Montserrat", sans-serif;
  font-weight: 500;
  font-style: normal;
  font-size: 0.92857rem !important;
  text-transform: uppercase;
  color: #ffffff;
  transition: 0.3s;
  letter-spacing: 3px;
}

.navbar__link:hover {
  color: #ff8152;
  transition: 0.3s;
}

.banner {
  background-color: rgba(0, 0, 0, 0.5);
  background-repeat: no-repeat;
  background-blend-mode: color;
  height: 100vh;
  display: grid;
  justify-items: center;
  align-items: center;
  background-size: cover;
  background-position: center center;
}

.banner__details {
  display: grid;
  gap: 35px;
  justify-items: center;
  width: 50%;
}

.banner__text {
  display: grid;
  gap: 15px;
  justify-items: center;
}

.banner__title h1 {
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-style: normal;
  /* text-transform: uppercase; */
  color: #ffffff;
  font-size: 40px;
  /* font-size: 2rem; */
  line-height: 40px;
  text-align: center;
}

.banner__description p {
  color: #ffffff;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  /* font-size: 1.21429rem; */
  font-size: 32px;
  text-align: center;
  line-height: 40px;
}

.title__section {
  display: grid;
  gap: 20px;
  justify-items: center;
  padding: 9.28571rem 0;
}

.title {
  color: #474849;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-style: normal;
  line-height: 40px;
  font-size: 32px;
}
.title__block {
  display: flex;
  flex-direction: column;
  gap: 10px;
}
.title__section-line {
  height: 1px;
  width: 70px;
  background-color: #263c44;
}

.apartments {
  display: grid;
  gap: 30px;
}
.apartments__information {
  display: flex;
  gap: 20px;
  width: 70%;
  margin: 0 auto;
  padding-bottom: 9.28571rem;
}
.apartments__details {
  width: 50%;
  display: grid;
  gap: 30px;
}
.apartments__information-plan {
  width: 50%;
}
.apartments__details-title {
  font-family: "Montserrat", sans-serif;
  font-weight: 700;
  font-style: normal;
  line-height: 1.4;
  color: #111111;
  font-size: 2.14286rem;
}

.apartments__details-description {
  color: #6c7072;
  font-size: 1.21429rem;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  line-height: 1.6;

  display: grid;
  gap: 15px;
}
.apartments__icon-list {
  display: grid;
  gap: 30px;
}
.apartments__icon-item {
  display: flex;
  align-items: center;
  gap: 10px;
}
.apartments__icon-description {
  color: #6c7072;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.21429rem;
}
.apartments__gallery {
  width: 100%;
}
.apartments__gallery-list {
  display: flex;
}
.object__gallery {
  width: 100%;
}
.object__gallery-list {
  display: flex;
}
.object__information {
  width: 70%;
  margin: 0 auto;
  display: grid;
  gap: 30px;
  padding: 60px 0;
  justify-items: center;
}
.object__information-line {
  height: 1px;
  width: 70%;
  background-color: #263c44;
}
.object__information-description {
  color: #6c7072;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 1.14286rem;
  line-height: 1.6;
}
.contact__information {
  width: 70%;
  margin: 0 auto;
  display: flex;
  gap: 20px;
}
.contacts {
  padding-bottom: 9.28571rem;
}

.contacts__title {
  text-align: left;
  color: #263c44;
  font-family: "Montserrat", sans-serif;
  font-weight: 600;
  font-style: normal;
  font-size: 2rem;
  line-height: 1.4;
}
.contacts__phone-details {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contacts__phone {
  display: grid;
  gap: 15px;
}
.contacts__time {
  display: flex;
  gap: 20px;
  align-items: center;
}
.contacts__sub-name {
  text-align: left;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #263c44;
  font-size: 1.14286rem;
}
.contacts__phone-details a {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #263c44;
  font-size: 1.21429rem;
}
.contact__details {
  width: 50%;
  display: grid;
  gap: 30px;
}

footer {
  background-color: #ffffff;
}
.footer-section {
  width: 70%;
  margin: 0 auto;
  padding: 2.85714rem 0;
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.footer-section__copyright {
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-style: normal;
  color: #474849;
  line-height: 1.6;
  font-size: 1rem;
  text-align: center;
}
@media (max-width: 1200px) {
  .menu {
    display: none;
  }
}
@media (max-width: 760px) {
  .saled {
    width: max-content;
  }
  .saled p {
    font-size: 12px;
  }
  main {
    gap: 40px;
  }
  .footer-section {
    gap: 15px;
    padding: 30px 0 15px;
  }
  .object__map {
    padding: 32px 0 16px;
  }
  .location__con {
    width: 90%;
  }
  .map-container {
    height: 255px;
  }
  .characteristics-container {
    width: 90%;
    flex-direction: column;
    align-items: start;
    gap: 16px;
    justify-content: start;
  }
  .characteristics-items {
    flex-direction: column;
    gap: 8px;
    align-items: start;
  }
  .characteristics-item {
    gap: 16px;
  }
  .characteristics-item svg {
    width: 24px;
    height: 24px;
  }
  .description {
    width: 90%;
    flex-direction: column;
  }
  .description__info {
    width: 100%;
  }
  .description__photo {
    width: 100%;
    height: 316px;
  }
  .photos__mobile {
    display: block;
  }
  .photos {
    display: none;
  }
  .header-container {
    width: 90%;
    flex-direction: column-reverse;
    gap: 30px;
    align-items: start;
  }
  .btn__block {
    width: auto;
  }
  .menu {
    display: none;
  }
  body {
    overflow-x: hidden;
  }
  .menu-triger {
    display: grid;
    width: 25px;
    height: 100%;
    background: url("") 0 0 no-repeat;
    position: absolute;
    right: 10px;
    top: 0;
    background-position: center;
  }
  .menu-close {
    display: block;
    width: 28px;
    height: 28px;
    background: url("") 0 0 repeat;
    position: absolute;
    right: 10px;
    top: 30px;
    z-index: 100;
  }
  header {
    position: absolute;
  }
  .menu-popup {
    display: none;
    background: #ffffff;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0;
    box-sizing: border-box;
    padding: 50px 20px;
    z-index: 9999;
    box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);
  }
  .nav__list {
    flex-direction: column;
  }
  .body_pointer * {
    cursor: pointer;
  }
  .logo {
    width: 25%;
  }
  .navbar__link {
    font-size: 0.92857rem;
  }
  .banner__details {
    width: 95%;
  }
  .banner__description p {
    line-height: 1.5;
    font-size: 17px;
  }
  .banner__title h1 {
    font-size: 1.8rem;
  }
  .title__section {
    padding: 3.57143rem 0;
  }
  .title {
    font-size: 1.4111rem;
    line-height: 1.4;
  }
  .apartments__information {
    width: 90%;
    flex-direction: column-reverse;
    align-items: center;
  }
  .apartments__information-plan {
    width: 100%;
  }
  .apartments__details {
    width: 100%;
  }
  .apartments__details-title {
    line-height: 1.4;
    font-size: 28px;
    text-transform: uppercase;
    text-align: center;
  }
  .apartments__details-description {
    text-align: center;
    font-size: 16px;
  }
  .apartments__icon-description {
    font-size: 16px;
  }
  .apartments__icon-list {
    gap: 14px;
  }
  .apartments__information {
    gap: 30px;
    padding-bottom: 30px;
  }
  .apartments__gallery-list {
    flex-direction: column;
    gap: 15px;
    padding: 30px 15px 0 15px;
  }
  .object__gallery-list {
    flex-direction: column;
    gap: 15px;
    padding: 30px 15px 0 15px;
  }
  .object__information {
    width: 90%;
    padding: 60px 0 30px 0;
  }
  .apartments__details-description {
    font-size: 16px;
  }
  .contact__information {
    width: 90%;
    flex-direction: column;
  }
  .contact__details {
    width: 100%;
  }
  .contacts__sub-name {
    font-size: 16px;
  }
  .contacts__phone-details a {
    font-size: 16px;
  }
  .contact__details {
    gap: 20px;
  }
  .contacts__phone {
    gap: 10px;
  }
}
</style>
